export default __webpack_public_path__ + "static/media/36t.1b61df8c.jpg";